import React from 'react';
export function FooterCTA() {
  return <section className="bg-blush py-24 md:py-32 border-b border-cardBorder" data-id="element-133">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-134">
        <div className="max-w-3xl mx-auto space-y-8 text-center" data-id="element-135">
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-magenta" data-id="element-136">
            Nu trebuie să treci prin asta singură.
          </h2>

          <p className="text-lg md:text-xl leading-relaxed text-navy" data-id="element-137">
            Rezervă o sesiune gratuită de evaluare 1 la 1 și hai să vedem
            împreună care este primul pas potrivit pentru tine.
          </p>

          <div className="pt-4" data-id="element-138">
            <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="inline-block bg-magenta text-white font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-cyan transition-colors duration-300" data-id="element-139">
              Rezervă Sesiunea CADOU de Evaluare
            </a>
          </div>
        </div>
      </div>
    </section>;
}